import { ChangeDetectionStrategy, Component, computed, input, output, Signal, WritableSignal } from '@angular/core';
import { NavbarButtonComponent } from '../../06_component/navbars/navbar-button/navbar-button.component';
import { ProcessStatus, ProcessStatusBadgeComponent } from "./process-status-badge/process-status-badge.component";
import { TabModel } from '../../05_layout/flat-layout/flat-tabs/tab.service';

export type Process = {
  doneManually: Signal<boolean>;
  doneAutomatically: Signal<boolean>;
  label: Signal<string>;
  url?: Signal<string>;
  name?: Signal<string>;
};

export type ProcessGroup = {
  label: Signal<string>;
  expanded: WritableSignal<boolean>;
  processes: Process[];
};

export type ProcessNavigationData = {
  processGroups: ProcessGroup[];
};

@Component({
  selector: 'tps-process-navigation',
  imports: [
    NavbarButtonComponent,
    ProcessStatusBadgeComponent,
],
  templateUrl: './process-navigation.component.html',
  styleUrls: ['./process-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessNavigationComponent {
  
  data = input.required<ProcessNavigationData>();
  articleID = input<string>('');
  route = input<string | undefined>();
  parentTab = input<TabModel | undefined>();
  processClicked = output<Process>();

  dataExtended = computed(() => {
    let nextProcess = null;
    let nextGroup = null;
    for (const group of this.data().processGroups) {
      for (const process of group.processes) {
        if (!process.doneAutomatically() && !process.doneManually()) {
          nextProcess = process;
          nextGroup = group;
          break;
        }
      }
      if (nextProcess) {
        break;
      }
    }

    return {
      processGroups: this.data().processGroups.map(group => {
        const processes = group.processes;
        const anyOpen = processes.some(p => !p.doneAutomatically() && !p.doneManually());
        const allDoneManually = processes.every(p => p.doneManually());
        const anyDoneAutomatically = processes.some(p => p.doneAutomatically());
        return {
          ...group,
          status: <ProcessStatus>(allDoneManually ? 'doneManually' : anyDoneAutomatically ? 'doneAutomatically' : anyOpen && group === nextGroup ? 'next' : 'open'),
          processes: processes.map(p => ({
            ...p,
            status: <ProcessStatus>(p.doneManually() ? 'doneManually' : p.doneAutomatically() ? 'doneAutomatically' : p === nextProcess ? 'next' : 'open'),
          })),
        };
      })
    };
  });

  getArrowIcon(expanded: boolean) {
    return expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_left';
  }
}
